import * as React from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import BadgeBorder from "src/presentation/common/atom/badge/badge_border";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstColor,
} from "../../../../config/styles_const/styles_const";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import { Occupation } from "../../../../domain/model/project";
import { extractOccupationsFromJobCareers } from "../../../../util/helper_job_career";
import ParagraphSup from "../../../common/atom/text/paragraph_sup";

interface IOwnProps {
  customer: Customer;
  jobCareers: JobCareer[];
  isBookmarked: boolean;
}

type IProps = IOwnProps & RouteComponentProps<{}>;

const SlideCustomerCard: React.FC<IProps> = (props) => {
  const { customer, jobCareers, isBookmarked, history } = props;
  const startPosRef = React.useRef<{ x: number; y: number } | null>(null);

  const occupations: Occupation[] =
    extractOccupationsFromJobCareers(jobCareers);
  const isOccupations: boolean = occupations.length !== 0;

  const handleMouseDown = (e: React.MouseEvent | React.TouchEvent) => {
    const pos = "touches" in e ? e.touches[0] : e;
    startPosRef.current = { x: pos.clientX, y: pos.clientY };
  };

  const handleMouseUp = (e: React.MouseEvent | React.TouchEvent) => {
    if (!startPosRef.current) {
      return;
    }

    const pos = "changedTouches" in e ? e.changedTouches[0] : e;
    const dx = Math.abs(pos.clientX - startPosRef.current.x);
    const dy = Math.abs(pos.clientY - startPosRef.current.y);

    // ドラッグでなければ（移動距離が小さければ）ナビゲーション
    if (dx < 10 && dy < 10) {
      history.push(`/client/scout/customer/${customer.id}`);
    }
    startPosRef.current = null;
  };

  return (
    <CardWrapper
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onTouchStart={handleMouseDown}
      onTouchEnd={handleMouseUp}
    >
      <Wrapper>
        <Inner>
          <CustomerImgWrapper>
            <Img src={customer.getIconURL()} />
          </CustomerImgWrapper>
        </Inner>
        <CustomerInfoWrapper>
          <CustomerNameInner>
            <CustomerName>{customer.jobCareerCatchphrase}</CustomerName>
          </CustomerNameInner>
          <CustomerNameInner>
            <CustomerName bold={true}>{customer.getCatchphrase()}</CustomerName>
          </CustomerNameInner>
          <Border />
          {customer.displayOccupationSkillCategories.length > 0 && (
            <OccupationBadgeWrapper>
              {customer.displayOccupationSkillCategories
                // .slice(0, 3)
                .map((val) => {
                  return (
                    <ScoutCustomerBadgeBorder key={val}>
                      {val}
                    </ScoutCustomerBadgeBorder>
                  );
                })}
            </OccupationBadgeWrapper>
          )}
          <CustomerAddressInner>
            {customer.address && (
              <CustomerAddress icon={'"\f3c5"'} bold={true}>
                {customer.address}
              </CustomerAddress>
            )}
            {isBookmarked && <FavoriteBadge bold={true} icon={"'\f004'"} />}
            <CustomerAge bold={true}>{customer.getAgeString()}</CustomerAge>
          </CustomerAddressInner>
          {/* <Inner>
            <CustomerDescription>{customer.pr}</CustomerDescription>
          </Inner> */}
        </CustomerInfoWrapper>
      </Wrapper>
    </CardWrapper>
  );
};

export default withRouter(SlideCustomerCard) as React.ComponentType<IOwnProps>;

export const CardLink = styled(Link)`
  color: ${ConstColor.Gray};
`;

const CardWrapper = styled.div`
  color: ${ConstColor.Gray};
  cursor: pointer;
`;

const Wrapper = styled.div`
  padding: 5px;
  width: 100%;
  height: 380px;
  box-shadow: 0px 0px 10px rgba(199, 199, 199, 0.2);
  border-radius: 10px;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
  }
`;

const Inner = styled.div`
  margin-bottom: 10px;
`;

const CustomerNameInner = styled(Inner)`
  height: 36px;
`;

const CustomerAddressInner = styled(Inner)`
  display: flex;
  height: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CustomerImgWrapper = styled.div`
  position: relative;
`;

const CustomerOccupationsWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  padding: 10px;
`;

const CustomerOccupations = styled.div`
  overflow: hidden;
  max-height: 54px;
`;

const OccupationBadge = styled.span`
  display: inline-block;
  padding: 3px 12px;
  margin: 5px 5px 0 0;

  background: ${ConstColor.White};
  /* placeholder+Border */

  border: 1px solid #d8d8d8;
  border-radius: 21px;

  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;

  color: ${ConstColor.Gray};
`;

const Img = styled.img`
  width: 100%;
  height: 172px;
  border-radius: 10px;
  object-fit: cover;
`;

const CustomerInfoWrapper = styled.div`
  padding: 0 5px;
`;

const Border = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgba(199, 199, 199, 0.2);
  margin-bottom: 10px;
`;

const CustomerName = styled(ParagraphSup)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CustomerAddress = styled(ParagraphSup)`
  color: ${ConstColor.Gray};
  display: inline;
  margin-right: 15px;
`;

const CustomerAge = styled(ParagraphSup)`
  color: ${ConstColor.Gray};
  display: inline;
  margin-right: 15px;
`;

const CustomerDescription = styled(ParagraphSup)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const FavoriteBadge = styled(ParagraphSup)`
  color: ${ConstColor.Corporate};
  display: inline;
`;

const OccupationBadgeWrapper = styled.div`
  margin-bottom: 10px;
`;

const ScoutCustomerBadgeBorder = styled(BadgeBorder)`
  color: ${ConstColor.Gray};
  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  background-color: ${ConstColor.White};
  border-radius: ${ConstBorderRound.BadgeBorder};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/top_page/slide_customer_card.tsx